type Provider = React.JSXElementConstructor<React.PropsWithChildren<any>>;

export const composeProviders = (providers: Provider[]) =>
  providers.reduce((Prev, Curr) => ({ children }) => (
    <Prev>
      <Curr>{children}</Curr>
    </Prev>
  ));
